import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import './FinalCTA.css';

const FinalCTA = () => {
  return (
    <section className="final-cta section" data-testid="final-cta-section">
      <div className="container">
        <div className="cta-card">
          <div className="cta-bg">
            <div className="cta-grid"></div>
            <div className="cta-glow"></div>
          </div>
          
          <div className="cta-content">
            <div className="cta-badge">
              <Sparkles size={16} />
              <span>Get Started Today</span>
            </div>
            
            <h2 className="cta-title" data-testid="cta-title">
              Build a Governance Layer<br />for AI Communication
            </h2>
            
            <p className="cta-description">
              Join enterprises using VantaSignal to control AI communication risk.
            </p>
            
            <div className="cta-actions" data-testid="cta-actions">
              <a 
                href="mailto:contact@vantasignal.app" 
                className="btn btn-primary btn-large"
                data-testid="cta-request-demo"
              >
                Request Demo
                <ArrowRight size={18} />
              </a>
              <a 
                href="mailto:hello@vantasignal.app?subject=VantaSignal Early Access" 
                className="btn btn-secondary btn-large"
                data-testid="cta-early-access"
              >
                Join Early Access
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
